import { useQuery } from '@tanstack/react-query';

import { usePublic } from '@/contexts/PublicContext';
import service from '@/services/index';

const useDetailFeedback = (feedbackId: string) => {
  const isPublic = usePublic();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['feedbacks', feedbackId],
    queryFn: () => service.feedback.fetchFeedbackDetail(feedbackId, isPublic),
  });

  return {
    data,
    isLoading,
    isError,
  };
};

export default useDetailFeedback;
